import * as z from "zod";

/**
 * Admin-only Recover activation initialization. This enables the shopper agent
 * and its shared Support/AI defaults without creating Recover automation
 * artifacts, which are configured only during Recover onboarding.
 */
export const enableRecoverShopperAgent = {
  name: "enableRecoverShopperAgent" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ success: z.literal(true) }),
};
